
module.exports = {

    getAvailableFieldworkersData: function(params) {
        return window.axios.get('get-available-fieldworkers', {params: params});
    },

}